import styled from 'styled-components'

export const Container = styled.header`
  position: sticky;
  top: 0;
  inset-inline: 0;
  z-index: 50;
  background: rgba(var(--surface), 0.92);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgb(var(--border));
`;

export const Content = styled.div`
  width: min(100%, 1200px);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 0.75rem;
  padding: calc(env(safe-area-inset-top, 0px) + 0.75rem) 1rem 0.75rem;
  margin: 0 auto;
  position: relative;

  @media (min-width: 768px) {
    padding-inline: 1.5rem;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
